const STORAGE_KEY = 'wapharma-notification-sound';

export const NOTIFICATION_SOUND_PREF_EVENT = 'wapharma-notification-sound-change';

let audioCtx: AudioContext | null = null;

export function isNotificationSoundEnabled(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'off';
  } catch {
    return true;
  }
}

export function setNotificationSoundEnabled(enabled: boolean): void {
  try {
    if (enabled) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, 'off');
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event(NOTIFICATION_SOUND_PREF_EVENT));
    }
  } catch {
    /* ignore */
  }
}

/** ponytail: Web Audio soft chime — no asset file; upgrade path = bundled mp3 + user pref UI */
export function playNotificationSound(): void {
  if (typeof window === 'undefined' || !isNotificationSoundEnabled()) return;
  try {
    audioCtx = audioCtx ?? new AudioContext();
    if (audioCtx.state === 'suspended') {
      void audioCtx.resume();
    }
    const t0 = audioCtx.currentTime;
    const osc = audioCtx.createOscillator();
    const gain = audioCtx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(740, t0);
    osc.frequency.exponentialRampToValueAtTime(988, t0 + 0.12);
    gain.gain.setValueAtTime(0.0001, t0);
    gain.gain.exponentialRampToValueAtTime(0.06, t0 + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.28);
    osc.connect(gain);
    gain.connect(audioCtx.destination);
    osc.start(t0);
    osc.stop(t0 + 0.3);
  } catch {
    /* autoplay policy or missing Web Audio */
  }
}
